module.exports = __webpack_public_path__ + "static/media/hilux-mk9-2021.8d9ddb15.jpg";